import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { trimPhoneNumber } from 'src/app/common-components/helpers/trim-phone-number-helper';
import { americanOrInternationalPhoneNumberValidator } from 'src/app/common-components/validators/phone-number.validator';
import {
   BlockedPhoneNumberDetailForm,
   BlockedPhoneNumberDetailFormValue,
} from '../models/blocked-phone-number-detail-form';
import { BlockedPhoneNumberDetailSaveModel } from '../models/blocked-phone-number-detail-save.model';

@Injectable()
export class BlockedPhoneNumberDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   constructor(private fb: UntypedFormBuilder) {
      super();

      const form: BlockedPhoneNumberDetailForm = {
         account: fb.control(null),
         blockedPhoneNumberId: fb.control(null),
         comment: fb.control(null, Validators.maxLength(50)),
         createDate: fb.control(null),
         createUser: fb.control(null),
         phoneNumber: this.fb.control(null, [Validators.required, americanOrInternationalPhoneNumberValidator()]),
         updateDate: fb.control(null),
         updateUser: fb.control(null),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   getValue(blockedPhoneNumberId: number | null): BlockedPhoneNumberDetailSaveModel {
      const value = this.form.value as BlockedPhoneNumberDetailFormValue;
      const blockedPhoneNumber: BlockedPhoneNumberDetailSaveModel = {
         accountId: value.account?.accountId ?? null,
         blockedPhoneNumberId: blockedPhoneNumberId,
         phoneNumber: trimPhoneNumber(value.phoneNumber),
         comment: value.comment,
      };
      return blockedPhoneNumber;
   }
}
